import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import empresaApi from "../api/empresaApi";

const emptyForm = {
    id: "",
    codigo: "",
    nombre: "",
    tipoIdentificacion: "NI",
    numeroIdentificacion: "",
    direccion: "",
    correo: "",
    telefono: "",
    estado: 1,
    logo: null,
};

export const useEmpresa = () => {
    const [empresas, setEmpresas] = useState([]);
    const [search, setSearch] = useState("");
    const [selected, setSelected] = useState(null);
    const [form, setForm] = useState(emptyForm);

    const loadEmpresas = async () => {
        try {
            const rs = await empresaApi.getAll();
            setEmpresas(rs.data || []);
        } catch (error) {
            toast.error("Error cargando empresas");
        }
    };

    useEffect(() => {
        loadEmpresas();
    }, []);

    const handleSelect = (e) => {
        setSelected(e.id);
        setForm({ ...emptyForm, ...e, logo: e.logo || null });
    };

    const handleNew = () => {
        setSelected(null);
        setForm(emptyForm);
    };

    const handleLogoChange = (file) => {
        if (!file) return;

        const validTypes = ["image/png", "image/jpeg", "image/jpg", "image/svg+xml", "image/webp"];
        if (!validTypes.includes(file.type)) {
            toast.warn("Formato no soportado. Seleccione una imagen en formato PNG, JPG, SVG o WEBP.");
            return;
        }

        const maxSize = 2 * 1024 * 1024; // 2 MB
        if (file.size > maxSize) {
            toast.warn("La imagen excede el tamaño máximo permitido de 2 MB.");
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            setForm((prev) => ({ ...prev, logo: reader.result }));
        };
        reader.onerror = () => {
            toast.error("Error al procesar la imagen seleccionada.");
        };
        reader.readAsDataURL(file);
    };

    const handleRemoveLogo = () => {
        setForm((prev) => ({ ...prev, logo: null }));
    };

    const saveEmpresa = async () => {
        if (!form.nombre || !form.codigo || !form.tipoIdentificacion || !form.numeroIdentificacion) {
            toast.warn("Nombre, código, tipo y número de identificación son obligatorios");
            return;
        }
        if (!/^\d+$/.test(form.codigo)) {
            toast.warn("El código prestador debe ser un valor numérico");
            return;
        }
        if (!/^\d+$/.test(form.numeroIdentificacion)) {
            toast.warn("El número de identificación debe ser numérico");
            return;
        }
        if (form.correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.correo)) {
            toast.warn("El correo ingresado no es válido");
            return;
        }
        if (form.telefono && !/^\d{10}$/.test(form.telefono)) {
            toast.warn("El teléfono debe tener exactamente 10 dígitos numéricos");
            return;
        }

        try {
            const rs = await empresaApi.save(form);
            if (rs.success) {
                toast.success(rs.data?.message || "Guardado con éxito");
                loadEmpresas();
                handleNew();
            } else {
                toast.error(rs.message || "Error al guardar");
            }
        } catch (error) {
            toast.error("Error al guardar empresa");
        }
    };

    return {
        empresas,
        search,
        setSearch,
        selected,
        form,
        setForm,
        handleSelect,
        handleNew,
        saveEmpresa,
        handleLogoChange,
        handleRemoveLogo,
    };
};
